import { ApproveInnovationAnnouce10DetailComponent } from "../../../components/SupportSystem/SupportForm/current/AppoveInnocationAnnouce10DetailComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function ApproveInnovationAnnouce10DetailContainer() {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <ApproveInnovationAnnouce10DetailComponent/>
            <Footer />
        </div>   
        // 
    )
    
}